var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 23C25.4477 23 25 23.4477 25 24C25 24.5523 25.4477 25 26 25V23ZM32 25C32.5523 25 33 24.5523 33 24C33 23.4477 32.5523 23 32 23V25ZM26 25H32V23H26V25Z",
    fill: "#0F90FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18C25.4477 18 25 18.4477 25 19C25 19.5523 25.4477 20 26 20V18ZM32 20C32.5523 20 33 19.5523 33 19C33 18.4477 32.5523 18 32 18V20ZM26 20H32V18H26V20Z",
    fill: "#0F90FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9977 19.5C11.9977 17.0147 14.0124 15 16.4977 15C18.983 15 20.9977 17.0147 20.9977 19.5C20.9977 21.9853 18.983 24 16.4977 24C14.0124 24 11.9977 21.9853 11.9977 19.5Z",
    stroke: "#0F90FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28.2298C11.3098 27.0198 12.0135 25.9474 13.0001 25.1815C13.9868 24.4157 15.2002 24 16.4492 24C17.6982 24 18.9117 24.4157 19.8983 25.1815C20.885 25.9474 21.5886 27.0198 21.8984 28.2298",
    stroke: "#0F90FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 13C7 11.8954 8.03319 11 9.30769 11H34.6923C35.9668 11 37 11.8954 37 13V31C37 32.1046 35.9668 33 34.6923 33H9.30769C8.03319 33 7 32.1046 7 31V13Z",
    stroke: "#0F90FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRg);
export default __webpack_public_path__ + "static/media/rg.ffad6ab5e4658b098facce42a9b41030.svg";
export { ForwardRef as ReactComponent };